import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SanctumService } from 'src/app/services/sanctum.service';
import { AuthHeaderService } from 'src/app/services/auth-header.service';
@Injectable({
  providedIn: 'root'
})
export class OgPreviewService {

  constructor(
    private authHeaderService: AuthHeaderService,
    private http: HttpClient,
    private sanctum: SanctumService) {
  }


    async getShopifyOgData(shopifyUrl: string): Promise<Observable<any>> {
      await this.sanctum.initSanctum();
    
      const storeId = Number(localStorage.getItem('ss_SelectedStoreId')) || 0;
    
      const httpOptions = await this.authHeaderService.getHttpOptions();
    
      const baseUrl = `${environment.apiBaseUrl}/api`;
    
      const url = `${baseUrl}/admin/store/${storeId}/opengraph`;
    
      const body = {
        url: shopifyUrl
      };
    
      return this.http.post<any>(url, body, httpOptions).pipe(
        catchError(error => {
          console.error('Erro ao obter dados OG da Shopify:', error);
          return throwError(() => error);
        })
      );
    }
    

  getAccessToken(): string {
    return localStorage.getItem('access_token') || '';
  }
}
